import { useQuery } from '@tanstack/react-query';
import { apiClinicGetClinicAdminData } from 'lib/api/firebase/apis/apis';
import { queryKeyFactory } from 'lib/utils/queryKeyFactory';

interface ClinicAdminDataQueryProps {
  uid: string | undefined;
  enabled: boolean;
}

export function useClinicAdminData(args: ClinicAdminDataQueryProps) {
  
  return useQuery({
    queryKey: queryKeyFactory.clinician.clinicAdminData(args.uid as string),
    queryFn: () => apiClinicGetClinicAdminData({ id: args.uid! }),
    enabled: args.enabled && !!args.uid,
  });
}
